import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../../../App';
import Dropdown from '../../../../Components/Dropdown/Dropdown';
import Modal from '../../../../Components/Modal/Modal';
import RadioButtonGroup from '../../../../Components/RadioButtonGroup/RadioButtonGroup';
import { Button, Input, Textarea } from '../../../../Components/StyledComponents';
import { convertCost, onlyNum } from '../../../../Utils/functions';
import './SetSMS.scss'

const SetSMS = ({smsTitle, setSMSTitle, smsText, setSMSText, coupon, setCoupon, type, couponInfo, setCouponInfo, condition, setCondition }) => {
    const [ couponList, setCouponList ] = React.useState([]);//보유 쿠폰 리스트
    const [ tempCoupon, setTempCoupon ] = React.useState('')//쿠폰 Id 임시저장
    const [ tempCouponInfo, setTempCouponInfo ] = React.useState({})//쿠폰 정보 임시저장

    useEffect(() => {
        getCouponList();
    },[])

    //보유 쿠폰 목록 get
    const getCouponList = () => {
        axios.get('/api/coupon')
        .then((data) => {
            setCouponList(data.data)
        })
    }

    //선택 쿠폰 해제
    const deleteCoupon = () => {
        setCoupon('')
        setCouponInfo({})
    }

    const modalRef = React.useRef(null);

    return (
        <div className='set-sms'>
            <div className="setsms-box">
                <p className="title">문자 설정</p>
                {
                    type === 'Retention' &&
                    <div className="row" style={{ marginBottom : 24 }}>
                        <p className="info-title">조건</p>
                        <Dropdown
                            value={condition.Day}
                            options={[
                                { key : '30일', value : 30},
                                { key : '60일', value : 60},
                                { key : '90일', value : 90},
                                { key : '180일', value : 180},
                            ]}
                            prefix='일'
                            onItemClick={(val) => setCondition({...condition, Day : val })}
                            width={760}
                        />
                    </div>
                }

                {
                    type === 'Point' &&
                    <div>
                        <div className="row" style={{ marginBottom : 24 }}>
                            <p className="info-title">이벤트 선택</p>
                            <RadioButtonGroup
                                id='type'
                                value={condition.Type}
                                options={[
                                    { label : '적립 횟수', value : '적립'},
                                    { label : '누적 결제 금액', value : '결제'},
                                ]}
                                radioStyle={{ marginRight : 16 }}
                                onChange={(val) => setCondition({...condition,Type : val })}
                                small
                            />
                            <p className='warn-text'>* 달성 시점마다 매번 발송돼요!</p>
                        </div>

                        <div className="row" style={{ marginBottom : 24 }}>
                            <p className="info-title">조건</p>
                            <Input
                                style={{ width : '100%', maxWidth : 776 }}
                                value={condition.Count}
                                onChange={(e) => setCondition({...condition,Count : onlyNum(e.target.value)})}
                                placeholder='조건을 입력해주세요.'
                            />
                        </div>
                    </div>
                }

                <div className="row">
                    <p className="info-title">문자 제목</p>
                    <Input
                        style={{ width : '100%', maxWidth : 776 }}
                        value={smsTitle}
                        onChange={(e) => setSMSTitle(e.target.value)}
                        placeholder='문자 제목을 입력해주세요.'
                    />
                </div>

                <div className="row" style={{ marginTop : 24, alignItems : 'flex-start' }}>
                    <p className="info-title">문자 내용</p>
                    <Textarea
                        style={{ width : '100%', maxWidth : 774, height : 224 }}
                        value={smsText}
                        onChange={(e) => setSMSText(e.target.value)}
                        placeholder='문자 내용을 입력해주세요.'
                    />
                </div>

                <div className="row" style={{ marginTop : 24 }}>
                    <p className="info-title">쿠폰 선택</p>
                    {
                        coupon === '' ?
                        <button className="coupon-btn" onClick={() => modalRef.current.openModal()}>
                            쿠폰 설정하기
                        </button>
                        :
                        <div className='selected-coupon-box'>
                            <div className='row'>
                                {
                                    couponInfo.Type === '상품증정' && <img src={require(`../../../../aseets/icons/coupon_gift.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                }
                                {
                                    couponInfo.Type === '원 할인' && <img src={require(`../../../../aseets/icons/coupon_won.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                }
                                {
                                    couponInfo.Type === '% 할인' && <img src={require(`../../../../aseets/icons/coupon_percent.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                }
                                {
                                    couponInfo.Type === '1+1' && <img src={require(`../../../../aseets/icons/coupon_plus.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                }
                                <div>
                                    <p className='selected-coupon-desc'>{couponInfo.Name} ({couponInfo.Type})</p>
                                    <p className='selected-coupon-title'>{couponInfo.Description}</p>
                                </div>
                            </div>
                            <div className='row'>
                                <button className='change-coupon-btn' onClick={() => modalRef.current.openModal()}>
                                    변경
                                </button>
                                <button className='delete-coupon-btn' onClick={() => deleteCoupon()}>
                                    삭제
                                </button>
                            </div>
                        </div>
                    }
                </div>

                <Modal ref={modalRef} contentContainer={{paddingBottom : 0, paddingLeft: 0, paddingRight : 0, overflow : 'hidden', width : 500, height : 'fit-content'}} onBackdropClick={() => {setTempCoupon(''); setTempCouponInfo({});modalRef.current.closeModal()}}>
                    <div className="coupon-modal">
                        <div className='row bewteen' style={{ marginBottom : 32, display : 'flex', justifyContent : 'space-between', paddingLeft : 40, paddingRight : 40 }}>
                            <p className="title">쿠폰 설정</p>
                            <img src={require('../../../../aseets/icons/close.svg').default} style={{ width : 32, height : 32,cursor : 'pointer' }} onClick={() => {setTempCoupon(''); setTempCouponInfo({});modalRef.current.closeModal()}}/>
                        </div>
                        <div className='coupon-select-list' style={{ paddingLeft : 40, paddingRight : 40 }}>
                            {
                                couponList.length === 0 ?
                                <p className='no-coupon'>생성된 쿠폰이 없습니다</p>
                                :
                                couponList.map((data,i) => {
                                    return(
                                        <div style={{ marginBottom : i === couponList.length - 1 ? 104 : 16 }} key={i} className={`coupon-box ${data._id.$oid === tempCoupon ? 'selected' : ''}`} onClick={() => {setTempCoupon(data._id.$oid); setTempCouponInfo(data)}}>
                                            <div className="coupon-type-box">
                                                {data.Type}
                                            </div>

                                            <p className="coupon-name">{data.Name}</p>
                                            <p className="coupon-desc">{data.Description}</p>
                                            <p className="coupon-info">유효기간 : {data.ExpiryPeriod}일 발행수 : {convertCost(data.IssuedCount)} 사용수 : {convertCost(data.UsedCount)} 반응률 : {(data.UsedCount/data.IssuedCount * 100).toFixed(2) === 'NaN' ? '0'  : (data.UsedCount/data.IssuedCount * 100).toFixed(2) }%</p>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        {
                            tempCoupon !== '' &&
                            <button className="coupon-select" onClick={() => {setCoupon(tempCoupon); setCouponInfo(tempCouponInfo); setTempCoupon(''); setTempCouponInfo({}); modalRef.current.closeModal() }}>
                                설정하기
                            </button>
                        }
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default SetSMS;